import axios from 'axios'
import { uri } from '../help/Api'
import { sto } from '../Context/InshData';

export const ACCOUNTINDEX_URL =uri+'Accounts_Index';

export function list(){
    return axios.get(ACCOUNTINDEX_URL)
}

export function create(data){

    return axios.post(ACCOUNTINDEX_URL, data);
}

export function update(data){
    return axios.put(ACCOUNTINDEX_URL, data)
}
export function remove(id){
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls =`Accounts_Index?id=${id}`
    } else {
      Urls =  `Accounts_Index?id=${id}&&db_name=${sto?.db_name}`
    } 
    return axios.delete(uri+Urls)
}

export default{ list, create, update, remove}